import axios from "axios";

 const MAIN_URL = "https://trinetskybk.pixonix.tech"
 export const axiosInstance = axios.create({baseURL: MAIN_URL});


 export default MAIN_URL;

